import { apiClient } from '@/services/ApiClient.js'

export class OrderItemService {
  query

  constructor(query) {
    this.query = query
  }

  getOrderItems() {
    return apiClient
      .get('order-items', {
        params: this.query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getOrderItem(id) {
    return apiClient
      .get('order-items/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  export() {
    return apiClient
      .get('order-items/export', {
        params: this.query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  update(productId, body) {
    return apiClient
      .patch('order-items/' + productId, body)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  updateOrderItem(id, body) {
    return apiClient
      .patch(`order-items/${id}/modify`, body)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
